<template>
  <div class="edit-platform">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">申请平台</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
        <el-form-item label="平台名称:" prop="name">
          <el-input v-model="ruleForm.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="公司名称:" prop="companyName">
          <el-input v-model="ruleForm.companyName" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="公司地区:" v-if="$route.query.auditStatus !== 'HANDLE'" class="is-required" prop="address">
          <el-select v-model="selectAddress.sheng" value-key="code" @change="getAllshi" clearable>
            <el-option v-for="(option, index) in address.sheng" :key="'provinces' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.shi" value-key="id" @change="getAllQu" clearable>
            <el-option v-for="(option, index) in address.shi" :key="'city' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.qu" value-key="id" clearable>
            <el-option v-for="(option, index) in address.qu" :key="'region' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司详细地址:" prop="addressVo" class="is-required">
          <el-input v-model="ruleForm.addressVo.fullAddress" style="width: 400px" maxlength="80"></el-input>
        </el-form-item>
        <el-form-item label="营业执照:">
          <div class="upload-img">
            <input type="file" name="" id="input_img" @change="upload($event)" />
            <div @click="uploadImg()" class="recharge-ok">上传文件</div>
          </div>
          <div id="show_img">
            <img :src="ruleForm.licenseUrl" alt="" v-if="ruleForm.licenseUrl.length > 0">
          </div>
          <p style="color: #999">支持格式：.jpg.png ，单个文件不能超过10MB，再次上传将替换</p>
        </el-form-item>
        <!-- <el-form-item label="子管理员订单隔离:" prop="subDataIsolation">
          <el-switch v-model="ruleForm.subDataIsolation" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item> -->
        <el-form-item label="平台类型:" prop="storeTypeid">
          <el-select clearable v-model="ruleForm.storeTypeid" @change="ruleForm.startups = 0">
            <el-option :label="item.name" :value="item.id" v-for="item in platformType" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否初创平台:" prop="startups" v-if="ruleForm.storeTypeid == 10010">
          <el-switch v-model="ruleForm.startups" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="影像季上传设计版模块:" prop="showProductCenter" v-show="false">
          <el-switch v-model="ruleForm.showProductCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" @change="showProductCenterChange"></el-switch>
        </el-form-item>
        <el-form-item label="产品中心:" prop="productCenter" v-if="ruleForm.showProductCenter">
          <el-switch v-model="ruleForm.productCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否调色:" prop="colorType">
          <el-select clearable v-model="ruleForm.colorType">
            <el-option :label="item.name" :value="item.id" v-for="item in colorTypes" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="noleft-third-title">
          <div class="third-title"><span>发货信息</span></div>
        </el-form-item>
        <el-form-item label="发货目的地:" prop="sendFlag">
          <el-radio v-model="ruleForm.sendFlag" label='0'>平台地址</el-radio>
          <el-radio v-model="ruleForm.sendFlag" label='1'>终端客户</el-radio>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="openSave" v-preventReClick>申请平台</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="dialogVisible" width="30%">
      <span>是否确定申请平台？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false, loading = false">取 消</el-button>
        <el-button type="primary" @click="addStore" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="申请成功" :visible.sync="applySuccessDialog" width="30%">
      <p>
        <span style="margin-right:20px;">平台号：{{ storeMsg.code }}</span>
        <span>平台名称：{{ storeMsg.name }}<br></span>
        <span>请等待审核人员审核</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="applySuccessDialog = false">取 消</el-button>
        <el-button type="primary" @click="applySuccessDialog = false, $router.go(-1)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { storeTypeGetStoreTypeList, storeUsable, storeApplyStore, addressGetCountyByCityId, addressGetCityByProvinceCode, addressGetAllProvince } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'edit-platform',
  components: {
  },
  data () {
    return {
      loading: false,
      address: {
        sheng: [],
        shi: [],
        qu: []
      },
      selectAddress: {
        sheng: {
          name: ''
        },
        shi: {
          name: ''
        },
        qu: {
          name: ''
        }
      },
      applySuccessDialog: false,
      dialogVisible: false,
      awsSdk: null,
      ruleForm: {
        showProductCenter: 1,
        productCenter: 1,
        colorType: 0,
        startups: 0,
        name: '',
        companyName: '',
        phone: '',
        licenseUrl: '',
        storeTypeid: '',
        skuNum: 4,
        address: {
          sheng: [],
          shi: [],
          qu: []
        },
        selectAddress: {
          sheng: [],
          shi: [],
          qu: []
        },
        addressVo: {
          city: '',
          cityId: '',
          county: '',
          countyId: '',
          fullAddress: '',
          id: '',
          province: '',
          provinceCode: ''
        },
        sendFlag: '0'
      },
      rules: {
        name: [
          {
            required: true,
            message: '请填写平台名称',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ],
        storeTypeid: [
          {
            required: true,
            message: '请选择平台类型',
            trigger: 'change'
          }
        ],
        companyName: [
          {
            min: 1,
            max: 20,
            message: '长度不能超过20个字符',
            trigger: 'blur'
          }
        ],
        platformTypeid: [{
          required: true,
          message: '请选择平台类型',
          trigger: 'change'
        }],
        sendFlag: [{
          required: true,
          message: '发货目的地:',
          trigger: 'change'
        }]
      },
      platformType: [],
      colorTypes: [{
        name: '根据产品设置调色',
        id: 0
      }, {
        name: '全不调色',
        id: 1
      }, {
        name: '全调色',
        id: 2
      }],
      storeMsg: {}
    }
  },
  created () {
    this.getAllSheng()
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    storeTypeGetStoreTypeList().then((res) => {
      this.platformType = res.data.data
    })
  },
  methods: {
    showProductCenterChange (val) {
      console.log('val', val)
      if (val == 1) {
        this.ruleForm.productCenter = 1
      } else {
        this.ruleForm.productCenter = 0
      }
    },
    getAllQu () {
      if (this.selectAddress.shi === '') {
        this.selectAddress.qu = ''
        return
      }
      addressGetCountyByCityId(this.selectAddress.shi.id).then(res => {
        if (res.data.success) {
          this.address.qu = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.qu.id }).length === 0) {
            this.selectAddress.qu = res.data.data[0]
          }
        }
      })
    },
    getAllshi () {
      if (this.selectAddress.sheng === '') {
        this.selectAddress.shi = ''
        this.selectAddress.qu = ''
        return
      }
      addressGetCityByProvinceCode(this.selectAddress.sheng.code).then(res => {
        if (res.data.success) {
          this.address.shi = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.shi.id }).length === 0) {
            this.selectAddress.shi = res.data.data[0]
            this.selectAddress.qu = ''
            this.getAllQu()
          }
        }
      })
    },
    getAllSheng () {
      addressGetAllProvince().then(res => {
        if (res.data.success) {
          this.address.sheng = res.data.data
        }
      })
    },
    addStore () {
      this.loading = true
      this.ruleForm.addressVo.city = this.selectAddress.shi.name
      this.ruleForm.addressVo.cityId = this.selectAddress.shi.id
      this.ruleForm.addressVo.county = this.selectAddress.qu.name
      this.ruleForm.addressVo.countyId = this.selectAddress.qu.id
      this.ruleForm.addressVo.province = this.selectAddress.sheng.name
      this.ruleForm.addressVo.provinceCode = this.selectAddress.sheng.code
      storeApplyStore(this.ruleForm).then(res => {
        if (res.data.success) {
          // this.$message.success('申请成功')
          this.loading = false
          this.dialogVisible = false
          this.storeMsg = res.data.data
          this.applySuccessDialog = true
          // this.$router.go(-1)
        }
      }).finally(() => {
        this.loading = false
        this.dialogVisible = false
      })
    },
    // input上传
    upload (e) {
      // this.$Loading.service({
      //   target: 'show_img'
      // })
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在上传',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadWebImg(e.target.files[0], this.$store.state.awsSdk.product.s3, [{ Key: '111', Value: '123123' }], function (precent) {
      })
        .then(res => {
          this.ruleForm.licenseUrl = res
          loading.close()
        })
    },
    // 点击上传
    uploadImg () {
      document.querySelector('#input_img').click()
    },
    // ----------------------------------------
    changeAddress (val) {
      this.ruleForm.addressVo = val
    },
    openSave () {
      if (JSON.stringify(this.selectAddress.qu.id !== undefined) !== JSON.stringify(this.ruleForm.addressVo.fullAddress !== '')) {
        this.$message.error('请完善地址信息')
        return
      }
      if (JSON.stringify(this.selectAddress.qu.id !== '') !== JSON.stringify(this.ruleForm.addressVo.fullAddress !== '')) {
        this.$message.error('请完善地址信息')
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let systemCode = (this.ruleForm.storeTypeid == 10010 || this.ruleForm.storeTypeid == 10012) ? 'BRIDAL' : this.ruleForm.storeTypeid == 10013 ? ' VIDEO' : 'PIYA'
          storeUsable({ act: 0, name: this.ruleForm.name, systemCode }).then(res => {
            if (res.data.success) {
              if (res.data.data.exist === true) {
                this.$message.error('平台名称已存在')
              } else {
                this.dialogVisible = true
              }
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
